import React from "react";
import { useTranslation } from "react-i18next";
import s from "./style.module.scss";

const InactiveSurveyMessage = () => {
  const { t } = useTranslation("surveyTaker");
  return (
    <div className={s.messageContainer}>
      <p className={s.message}>{t("surveyTaker:inactiveSurvey")}</p>
    </div>
  );
};
export default InactiveSurveyMessage;
